import React from 'react'
import styles from './Spacer.module.scss'

interface SpacerProps {
  size?: 'auto'
  className?: never
}

export const Spacer: React.FC<SpacerProps> = () => (
  <div className={styles.spacer} aria-hidden="true" />
)
